import React from "react";
import "./Formatter.scss";
const Formatter = ({ header, children }) => {
  return (
    <div className="formatter">
      <div className="formatterHeader">{header}</div>
      <hr />
      {children}
    </div>
  );
};
export default Formatter;
